/* import __COLOCATED_TEMPLATE__ from './buyer-feedback-is-complete.hbs'; */
import Component from '@ember/component';

export default Component.extend({
  /** @inheritDoc */
  tagName: 'aside',

  /** @inheritDoc */
  classNames: ['buyer-feedback'],

  /** @inheritDoc */
  classNameBindings: ['hidden:buyer-feedback--hidden'],

  /** @type {boolean} */
  hidden: false,

  /** @type {number} */
  handler: 0,

  /** @param {function} */
  onCompleteCallback: undefined,

  /** @inheritDoc */
  didInsertElement() {
    this._super(...arguments);

    this.set('handler', setTimeout(() => {
      this.setProperties({ handler: 0, hidden: true });

      this.element.addEventListener('transitionend', () => {
        this.onCompleteCallback();
      });
    }, 2 * 1000));
  },

  /** @inheritDoc */
  willDestroyElement() {
    this._super(...arguments);

    const timeout = this.get('handler');

    if (timeout) {
      clearTimeout(timeout);
    }
  },
});
